module.exports = __webpack_public_path__ + "144316dbf92940e3d092e52ffd0c8d9a.png";